import React, { useEffect } from 'react' 
import { useAppContext } from "../Context/Store";
import parse from 'html-react-parser';

export default function TermAndConditionPage({ sendBodyClass }) {

    const { isError, isLoading, TermAndConditionData } = useAppContext();
  
    if(isError){
      //console.log("Home Page Component", contextData); 
      return <div>Error Term and Condition Page...</div>;  // Handle Error state
    }

    if (!TermAndConditionData || isLoading) {
      return <div>Loading...</div>;  // Handle loading state
    }
    
    const { properties } = TermAndConditionData;
    
    useEffect(() => {
      sendBodyClass(false);
    },[])
  return (
    <>
      <section className="about-txt faqs">
        <div className="inner">
            <article>
                <div className="info">
                {parse(`${properties?.descriptionText?.markup || " "}`)}
                </div> 
            </article> 
        </div>
    </section> 
    </>
  )
}